import React from 'react';

import './Dashboard.css';

function Stats({ children, ...rest }) {
  return (
    <section {...rest}>
      {children}
    </section>
  );
}

export default Stats;
